import React from 'react';

import { Box, Typography, IconButton, Button } from '@mui/material';

import { useDeleteFavoriteCodeMutation } from '../../../apis/FlorenceApi';
import { ReactComponent as BookmarkIcon } from '../../../assets/icons/bookmark_icon.svg';
import { ReactComponent as BookmarkIconOutlined } from '../../../assets/icons/boomark_icon_gray.svg';
import { ReactComponent as ChevronDownIcon } from '../../../assets/icons/chevron_down_icon.svg';
import { SavedCode } from '../../../types/Codes';
import './SavedCodeCellFlorence.scss';

type Props = {
  code: SavedCode;
};

const SavedCodeCellFlorence: React.FC<Props> = ({ code }) => {
  const [isOpen, setIsOpen] = React.useState(false);

  const [deleteTrigger] = useDeleteFavoriteCodeMutation();

  const handleRotate = () => setIsOpen(!isOpen);

  const rotate = isOpen ? 'rotate(180deg)' : 'rotate(0)';

  const handleDelete = async () => {
    await deleteTrigger(code);
  };

  const renderRow = (workRVU: string, totalRVU: string, bottom: boolean) => {
    return (
      <Box className='row wrapper-details-row'>
        {code.work_rvu && (
          <Box className='row' sx={{ mr: '36px' }}>
            <Typography
              sx={{ marginRight: '8px' }}
              fontFamily={'SFProDisplay-Bold'}
            >
              {workRVU}
            </Typography>
            <Typography
              color='textFlorenceSecondary.main'
              fontFamily={'SFProDisplay-Regular'}
            >
              Work RVU
            </Typography>
          </Box>
        )}
        {code.facility_total && (
          <Box className='row'>
            <Typography
              sx={{ marginRight: '8px' }}
              fontFamily={'SFProDisplay-Bold'}
            >
              {totalRVU}
            </Typography>
            <Typography
              color='textFlorenceSecondary.main'
              fontFamily={'SFProDisplay-Regular'}
            >
              Total NF-RVU
            </Typography>
          </Box>
        )}
      </Box>
    );
  };

  return (
    <Box
      className='table-view-cell-container'
      position='relative'
      sx={{
        backgroundColor: '#fff',
        marginBottom: '16px',
      }}
    >
      <BookmarkIcon
        style={{
          position: 'absolute',
          top: -2,
          left: 18,
        }}
      />
      <Box
        sx={{
          justifyContent: 'space-between',
        }}
        className='row'
      >
        <Box className='row favorite-code-container'>
          <Typography
            sx={{ marginRight: '20px' }}
            variant='subtitle'
            fontFamily={'SFProDisplay-Bold'}
            className='favorite-code-code'
          >
            {code.code}
          </Typography>
          <Typography
            color='textFlorenceSecondary.main'
            fontFamily={'SFProDisplay-Regular'}
            className='favorite-code-description'
          >
            {code.description}
          </Typography>
        </Box>
        <IconButton
          sx={{
            transform: rotate,
            transition: 'all 0.25s ease-in-out',
            alignSelf: 'flex-start',
          }}
          onClick={() => handleRotate()}
          className={`${isOpen ? 'icon-selected' : 'icon'}`}
        >
          <ChevronDownIcon />
        </IconButton>
      </Box>
      {isOpen && (
        <Box
          sx={{
            mt: '8px',
            display: 'flex',
            justifyContent: 'space-between',
            flexDirection: 'row',
            width: '100%',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
            }}
          >
            {renderRow(code.work_rvu ?? '', code.facility_total ?? '', false)}
          </Box>
          <Button
            onClick={handleDelete}
            variant='text'
            startIcon={<BookmarkIconOutlined />}
          >
            <Typography color='text.secondary'>Unsave</Typography>
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default SavedCodeCellFlorence;
